import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { TextFieldAtom, ModalAtom } from "../../../../components/atoms/atom";
import { EXTERNAL_SYSTEM_IDENTIFIER_REGEX } from "../../../../utils/constant";

function AddProcessModal(props) {
    const { show, onClose, onSubmit, mode, processInfo = {}  } = props;
    const { t } = useTranslation();

    const [nameObj, setNameObj] = useState({
        value: processInfo?.name ? processInfo.name: '',
        error: '',
    });
    const [externalSystemIdentifierObj, setExternalSystemIdentifierObj] = useState({
        value: processInfo?.externalSystemIdentifier || '',
        error: '',
    })

    const onAddProcess = () => {
        if (!nameObj.value) {
            setNameObj({...nameObj, error: 'error-process-name-required'});
            return;
        }
        if (!externalSystemIdentifierObj.value) {
            setNameObj({...nameObj, error: 'error-external-system-identifier-required'});
            return;
        }   
        onSubmit({
            ...processInfo,
            name: nameObj.value,
            externalSystemIdentifier: externalSystemIdentifierObj.value,
        });      
    }

    return (
        <ModalAtom 
            title={t(mode === 'add' ? 'add-process' : 'edit-process')}
            show={show} 
            handleClose={onClose}
            handleSubmit={onAddProcess}
            body={ <Container>
                <Row>
                    <Col>
                        <TextFieldAtom 
                            type="text"
                            placeholder={t('name')}
                            required
                            value={nameObj.value}
                            error={nameObj.error}
                            onChange={(e) => {
                                setNameObj({...nameObj, 
                                    value: e.target.value, 
                                    error: e.target.value ? '' : 'error-process-name-required'
                                })
                            }}
                        />
                    </Col>
                    <Col>
                        <TextFieldAtom 
                            type="text"
                            placeholder={t('external-system-identifier')}
                            required
                            value={externalSystemIdentifierObj.value}
                            error={externalSystemIdentifierObj.error}
                            onChange={(e) => {
                                if (e.target.value.match(EXTERNAL_SYSTEM_IDENTIFIER_REGEX)) {
                                    setExternalSystemIdentifierObj({...externalSystemIdentifierObj, 
                                        value: e.target.value.toUpperCase(),
                                        error: e.target.value ? '' : 'error-external-system-identifier-required'
                                    })
                                }
                            }}
                        />
                    </Col>
                </Row>
            </Container>}
        />
    );
}

export default AddProcessModal;
